import { render, staticRenderFns } from "./toExamineBankCard.vue?vue&type=template&id=1875b994&scoped=true&"
import script from "./toExamineBankCard.vue?vue&type=script&lang=js&"
export * from "./toExamineBankCard.vue?vue&type=script&lang=js&"
import style0 from "./toExamineBankCard.vue?vue&type=style&index=0&id=1875b994&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1875b994",
  null
  
)

export default component.exports